import { render, staticRenderFns } from "./activityPrice.vue?vue&type=template&id=72c880b6&scoped=true&"
import script from "./activityPrice.vue?vue&type=script&lang=js&"
export * from "./activityPrice.vue?vue&type=script&lang=js&"
import style0 from "./activityPrice.vue?vue&type=style&index=0&id=72c880b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c880b6",
  null
  
)

export default component.exports